import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../Context';
import { AuthContextApi } from '../../Context/api';
import {
    CheckCircleIcon,
    ArrowDownIcon,
    ArrowUpIcon,
    EnvelopeIcon,
    KeyIcon,
    UserIcon,
    ExclamationTriangleIcon,
    CheckIcon
} from '@heroicons/react/20/solid';
import moment from 'moment';

const Perfil = () => {

    const { states, setters } = useContext(AuthContext)
    const { checkLogin,
        profileChangeEmail,
        profileChangeSenha } = useContext(AuthContextApi)
    const [emailUsuario, setEmailUsuario] = useState('')
    const [cumprimento, setCumprimento] = useState('')
    const [trocarSenha, setTrocarSenha] = useState(true)

    const [email, setEmail] = useState('')
    const [senha, setSenha] = useState('')
    const [novaSenha, setNovaSenha] = useState('')
    const [confirmarSenha, setConfirmarSenha] = useState('')
    const [errorEmail, setErrorEmail] = useState(false)
    const [errorEmailMessage, setErrorEmailMessage] = useState('Campo obrigatório')
    const [errorSenha, setErrorSenha] = useState(false)
    const [errorSenhaMensagem, setErrorSenhaMensagem] = useState('Campo obrigatório')
    const [errorNovaSenha, setErrorNovaSenha] = useState(false)
    const [errorConfirmarSenha, setErrorConfirmarSenha] = useState(false)





    const primeiroLoad = async () => {
        await checkLogin()
    }


    const getGreeting = () => {
        const hour = moment().hour(); // Pega a hora atual
        if (hour < 12) {
            setCumprimento('Bom dia')
        } else if (hour < 18) {
            setCumprimento('Boa tarde')
        } else {
            setCumprimento('Boa noite')
        }
    };


    const actionButton = async (modo) => {
        let error = false;


        if (senha === '') {
            setErrorSenha(true)
            setErrorSenhaMensagem('Campo obrigatório')
            error = true
        } else setErrorSenha(false)

        let obj = {};
        if (modo === 'senha') {
            if (novaSenha === '') {
                setErrorNovaSenha(true)
                error = true
            } else setErrorNovaSenha(false)

            if (confirmarSenha === '') {
                setErrorConfirmarSenha(true)
                error = true
            } else setErrorConfirmarSenha(false)

            if (novaSenha !== confirmarSenha) {
                setErrorNovaSenha(true)
                setErrorSenhaMensagem('As senhas não coincidem')
                error = true
            } else {
                setErrorNovaSenha(false)
                setErrorSenhaMensagem('Campo obrigatório')
            }
            const isStrongerPassword = novaSenha.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).{8,}$/)
            if (!isStrongerPassword) {
                setErrorNovaSenha(true)
                setErrorSenhaMensagem('A senha deve conter no mínimo 8 caracteres, uma letra maiúscula e um número')
                error = true
            } else {
                setErrorNovaSenha(false)
                setErrorSenhaMensagem('Campo obrigatório')
            }
            obj = {
                senha: senha,
                novaSenha
            }
        } else {
            if (email === '') {
                setErrorEmail(true)
                setErrorEmailMessage('Campo obrigatório')
                error = true
            } else setErrorEmail(false)

            const getMailStorage = localStorage.getItem('usuario')
            if (email === getMailStorage) {
                setErrorEmail(true)
                setErrorEmailMessage('O e-mail não pode ser igual ao atual')
                error = true
            } else {
                setErrorEmail(false)
                setErrorEmailMessage('Campo obrigatório')
            }
            obj = {
                email: email,
                senha: senha
            }

        }
        if (error) {
            error = false;
            return;
        }

        if (modo === 'senha') {
            const resp = await profileChangeSenha(obj)
            if (resp.status === false) {
                setErrorSenha(true)
            } else {
                setErrorSenha(false)
                setSenha('')
                setNovaSenha('')
                setConfirmarSenha('')
                setErrorSenhaMensagem('Campo obrigatório')
            }
        } else {
            const resp = await profileChangeEmail(obj)
            if (resp.status === false) {
                setErrorEmail(true)
            } else {
                setErrorEmail(false)
                setEmail('')
                setSenha('')
                setErrorEmailMessage('Campo obrigatório')
            }
        }

    }


    useEffect(() => {
        primeiroLoad()
        getGreeting()
        setEmailUsuario(localStorage.getItem('usuario'))
    }, [])

    useEffect(() => {
        setErrorConfirmarSenha(false)
        setErrorEmail(false)
        setErrorNovaSenha(false)
        setErrorSenha(false)
        if (trocarSenha) {
            setEmail(localStorage.getItem('usuario'))
            setSenha('')
            setNovaSenha('')
            setConfirmarSenha('')
        } else {
            setEmail('')
            setSenha('')
            setNovaSenha('')
            setConfirmarSenha('')

        }
    }, [trocarSenha])


    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 p-4">
            {/* Header */}
            <div className="mb-8">
                <div className="flex items-center space-x-4 mb-6">
                    <div className="p-3 bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl shadow-lg">
                        <UserIcon className="w-8 h-8 text-white" />
                    </div>
                    <div>
                        <h1 className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                            Meu Perfil
                        </h1>
                        <p className="text-gray-600">Gerencie suas informações pessoais</p>
                    </div>
                </div>

                {/* Cumprimento */}
                <div className="bg-white rounded-2xl p-6 shadow-lg mb-6">
                    <div className="flex items-center space-x-3">
                        <CheckCircleIcon className="w-6 h-6 text-green-500" />
                        <div>
                            <h2 className="text-xl font-semibold text-gray-900">
                                {cumprimento}, {emailUsuario}
                            </h2>
                            <p className="text-gray-600">Você está logado com sucesso!</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Toggle Operação */}
            <div className="bg-white rounded-2xl p-2 shadow-lg mb-6">
                <div className="flex">
                    <button
                        type="button"
                        className={`flex-1 px-4 py-3 rounded-xl text-sm font-medium transition-all ${trocarSenha ? 'bg-purple-600 text-white shadow-md' : 'text-gray-700 hover:bg-gray-50'}`}
                        onClick={() => setTrocarSenha(true)}
                    >
                        Alterar Senha
                    </button>
                    <button
                        type="button"
                        className={`flex-1 px-4 py-3 rounded-xl text-sm font-medium transition-all ${!trocarSenha ? 'bg-blue-600 text-white shadow-md' : 'text-gray-700 hover:bg-gray-50'}`}
                        onClick={() => setTrocarSenha(false)}
                    >
                        Alterar E-mail
                    </button>
                </div>
            </div>

            {/* Seções de Configuração */}
            <div className="space-y-6">
                {!trocarSenha && (
                    <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                        <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-6">
                            <div className="flex items-center space-x-3">
                                <EnvelopeIcon className="w-6 h-6 text-white" />
                                <div>
                                    <h3 className="text-xl font-semibold text-white">Alterar E-mail</h3>
                                    <p className="text-blue-100">Atualize seu endereço de e-mail</p>
                                </div>
                            </div>
                        </div>

                        <div className="p-6">
                            <div className="space-y-4">
                                {/* E-mail atual */}
                                <div className="bg-gray-50 rounded-xl p-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        E-mail Atual
                                    </label>
                                    <div className="flex items-center space-x-2">
                                        <EnvelopeIcon className="w-5 h-5 text-gray-400" />
                                        <span className="text-gray-900 font-medium">{emailUsuario}</span>
                                    </div>
                                </div>

                                {/* Novo e-mail */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Novo E-mail *
                                    </label>
                                    <input
                                        type="email"
                                        className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 ${errorEmail ? 'border-red-300 bg-red-50' : 'border-gray-300'
                                            }`}
                                        placeholder="Digite seu novo e-mail"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                    {errorEmail && (
                                        <div className="mt-2 flex items-center space-x-2 text-red-600">
                                            <ExclamationTriangleIcon className="w-4 h-4" />
                                            <span className="text-sm">{errorEmailMessage}</span>
                                        </div>
                                    )}
                                </div>

                                {/* Senha atual para confirmação */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Senha Atual *
                                    </label>
                                    <input
                                        type="password"
                                        className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 ${errorSenha ? 'border-red-300 bg-red-50' : 'border-gray-300'
                                            }`}
                                        placeholder="Digite sua senha atual para confirmar"
                                        value={senha}
                                        onChange={(e) => setSenha(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                actionButton('email')
                                            }
                                        }}
                                    />
                                    {errorSenha && (
                                        <div className="mt-2 flex items-center space-x-2 text-red-600">
                                            <ExclamationTriangleIcon className="w-4 h-4" />
                                            <span className="text-sm">{errorSenhaMensagem}</span>
                                        </div>
                                    )}
                                </div>

                                {/* Botão de ação */}
                                <div className="flex justify-end">
                                    <button
                                        onClick={() => {
                                            actionButton('email')
                                        }}
                                        className="px-6 py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-xl hover:shadow-lg transition-all duration-300 transform hover:scale-105"
                                    >
                                        <div className="flex items-center space-x-2">
                                            <EnvelopeIcon className="w-5 h-5" />
                                            <span>Alterar E-mail</span>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Seção de Alteração de Senha */}
                {trocarSenha && (
                    <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                        <div className="bg-gradient-to-r from-purple-500 to-purple-600 p-6">
                            <div className="flex items-center space-x-3">
                                <KeyIcon className="w-6 h-6 text-white" />
                                <div>
                                    <h3 className="text-xl font-semibold text-white">Alterar Senha</h3>
                                    <p className="text-purple-100">Atualize sua senha de acesso</p>
                                </div>
                            </div>
                        </div>

                        <div className="p-6">
                            <div className="space-y-4">
                                {/* Senha atual */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Senha Atual *
                                    </label>
                                    <input
                                        type="password"
                                        className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300 ${errorSenha ? 'border-red-300 bg-red-50' : 'border-gray-300'
                                            }`}
                                        placeholder="Digite sua senha atual"
                                        value={senha}
                                        onChange={(e) => setSenha(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                actionButton('senha')
                                            }
                                        }}
                                    />
                                    {errorSenha && (
                                        <div className="mt-2 flex items-center space-x-2 text-red-600">
                                            <ExclamationTriangleIcon className="w-4 h-4" />
                                            <span className="text-sm">{errorSenhaMensagem}</span>
                                        </div>
                                    )}
                                </div>

                                {/* Nova senha */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Nova Senha *
                                    </label>
                                    <input
                                        type="password"
                                        className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300 ${errorNovaSenha ? 'border-red-300 bg-red-50' : 'border-gray-300'
                                            }`}
                                        placeholder="Digite sua nova senha"
                                        value={novaSenha}
                                        onChange={(e) => setNovaSenha(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                actionButton('senha')
                                            }
                                        }}
                                    />
                                    {errorNovaSenha && (
                                        <div className="mt-2 flex items-center space-x-2 text-red-600">
                                            <ExclamationTriangleIcon className="w-4 h-4" />
                                            <span className="text-sm">{errorSenhaMensagem}</span>
                                        </div>
                                    )}
                                </div>

                                {/* Confirmar nova senha */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Confirmar Nova Senha *
                                    </label>
                                    <input
                                        type="password"
                                        className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300 ${errorConfirmarSenha ? 'border-red-300 bg-red-50' : 'border-gray-300'
                                            }`}
                                        placeholder="Confirme sua nova senha"
                                        value={confirmarSenha}
                                        onChange={(e) => setConfirmarSenha(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                actionButton('senha')
                                            }
                                        }}
                                    />
                                    {errorConfirmarSenha && (
                                        <div className="mt-2 flex items-center space-x-2 text-red-600">
                                            <ExclamationTriangleIcon className="w-4 h-4" />
                                            <span className="text-sm">Campo obrigatório</span>
                                        </div>
                                    )}
                                </div>

                                {/* Requisitos da senha */}
                                <div className="bg-purple-50 border border-purple-200 rounded-xl p-4">
                                    <h4 className="text-sm font-medium text-purple-800 mb-2">Requisitos da senha:</h4>
                                    <ul className="text-sm text-purple-700 space-y-1">
                                        <li className="flex items-center space-x-2">
                                            <CheckIcon className="w-4 h-4 text-purple-600" />
                                            <span>Mínimo 8 caracteres</span>
                                        </li>
                                        <li className="flex items-center space-x-2">
                                            <CheckIcon className="w-4 h-4 text-purple-600" />
                                            <span>Pelo menos uma letra maiúscula</span>
                                        </li>
                                        <li className="flex items-center space-x-2">
                                            <CheckIcon className="w-4 h-4 text-purple-600" />
                                            <span>Pelo menos um número</span>
                                        </li>
                                        <li className="flex items-center space-x-2">
                                            <CheckIcon className="w-4 h-4 text-purple-600" />
                                            <span>Pelo menos um caractere especial (@$!%*?&)</span>
                                        </li>
                                    </ul>
                                </div>

                                {/* Botão de ação */}
                                <div className="flex justify-end">
                                    <button
                                        onClick={() => {
                                            actionButton('senha')
                                        }}
                                        className="px-6 py-3 bg-gradient-to-r from-purple-500 to-purple-600 text-white rounded-xl hover:shadow-lg transition-all duration-300 transform hover:scale-105"
                                    >
                                        <div className="flex items-center space-x-2">
                                            <KeyIcon className="w-5 h-5" />
                                            <span>Alterar Senha</span>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )

}



export default Perfil;